import { BaseWorkflow } from "./BaseWorkflow";
export class Orchestrator extends BaseWorkflow {
    constructor(orchestratorId, socket) {
        super(socket);
        this.orchestratorId = orchestratorId;
    }
    channelName() { return `orch_com_${this.orchestratorId}`; }
    async thread(thread_id) {
        const sub = await this._getSubscription();
        // Bypass channelConfig.orchestratorEnabled gate: this code path is
        // entered only via adk.orchestrator(id), which is itself the opt-in.
        return sub._threadUnchecked(thread_id);
    }
}
